export const VariableIcon = ({ color = 'currentColor', ...props }: JSX.IntrinsicElements['svg']) => {
  return (
    <svg width='15' height='17' viewBox='0 0 15 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M13.8945 4.55762V11.9414L7.5 15.6338L1.10547 11.9414V4.55762L7.5 0.865234L13.8945 4.55762Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <circle opacity='0.5' cx='7.5' cy='8.25' r='2.25' fill={color} />
    </svg>
  );
};
